<template>
  <div class="receipts-add mt-1">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Sửa phiếu thu</h1>
      <div class style="float: right">
        <button type="button" class="btn btn-light" @click="checkCloseEdit()">Hủy bỏ</button>
        <button
          class="btn btn-outline-secondary ml-2"
          @click="sendApproved()"
          v-if="dataReceipt.paymentType === 'CUSTOMER_TRANSFER' && dataReceipt.status === 'NEW'"
        >
          Gửi duyệt
        </button>
        <button type="button" class="btn btn-primary ml-2" @click="updateReceipt()">Lưu lại</button>
      </div>
    </div>

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div>
        <ValidationObserver ref="receiptsEdit" class="card-body px-20 mt-2 row">
          <form class="col-md-6">
            <h1 class="form-inner-heading mb-1">Thông tin</h1>

            <ValidationProvider rules="required" vid="merchantName" name="Merchant">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label"
                  >Merchant <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <input
                    type="text"
                    disabled
                    v-model="dataReceipt.merchantName"
                    placeholder="Chọn merchant"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required" vid="contract" name="Hợp đồng">
              <div class="form-group row" slot-scope="{ errors }">
                <label class="col-sm-3 col-form-label"
                  >Số hợp đồng <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <input
                    type="text"
                    class="select-contract"
                    v-model="dataReceipt.contractCode"
                    disabled
                    placeholder="Chọn loại hợp đồng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <div class="form-group row" v-if="dataReceipt.appendixCode">
              <label for class="col-sm-3 col-form-label">Số phụ lục</label>
              <div class="col-sm-7">
                <input
                  type="text"
                  class="select-appendix"
                  v-model="dataReceipt.appendixCode"
                  disabled
                />
              </div>
            </div>

            <div class="form-group row">
              <label for class="col-sm-3 col-form-label">Mã phiếu thu</label>
              <div class="col-sm-7">
                <input
                  v-model="dataReceipt.receiptCode"
                  type="text"
                  disabled
                  class="form-control"
                />
              </div>
            </div>

            <div class="form-group row">
              <label for class="col-sm-3 col-form-label">Số tiền phải thu</label>
              <div class="col-sm-7">
                <input v-model="dataReceipt.amount" type="text" disabled class="form-control" />
              </div>
            </div>

            <ValidationProvider rules="required" vid="paymentType" name="Hình thức thanh toán">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Hình thức thanh toán <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <Select2
                    class="select-payment-type"
                    v-model="dataReceipt.paymentType"
                    :options="dataTypePayment"
                    @select="selectPaymentType()"
                    placeholder="Chọn hình thức"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <!-- <div class="form-group row">

              <div class="col-sm-7">
                <input
                  v-model="dataReceipt.netAmount"
                  type="text"
                  class="form-control"
                />
              </div>
            </div> -->
            <ValidationProvider
              v-if="dataReceipt.paymentType === 'E_COMMERCE'"
              rules="required"
              vid="netAmount"
              name="Ngày đã thu"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Số tiền thực nhận <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <input v-model="dataReceipt.netAmount" type="number" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="required" vid="receiptDate" name="Ngày đã thu">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Ngày đã thu <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <datepicker
                    format="dd/MM/yyyy"
                    :language="vi"
                    class="receipt-date"
                    v-model="dataReceipt.receiptDate"
                    placeholder="Chọn ngày đã thu"
                  ></datepicker>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <!-- <div class="form-group row"
              v-if="dataReceipt.paymentType &&
                  dataReceipt.paymentType === 'CUSTOMER_TRANSFER'"
            >
              <label for class="col-sm-3 col-form-label"
                >Nội dung phải thu</label
              >
              <div class="col-sm-7">
                <input
                  v-model="dataReceipt.description"
                  type="text"
                  disabled
                  class="form-control"
                />
              </div>
            </div> -->

            <ValidationProvider rules="required" vid="transactionCode" name="Mã giao dịch">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">
                  Mã giao dịch đã thu<span style="color: red">*</span>
                </label>
                <div class="col-sm-7">
                  <div class="input-group">
                    <input
                      type="text"
                      v-model="dataReceipt.transactionCode"
                      class="form-control"
                      :readonly="selectedTransactions.length > 0"
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-outline-secondary"
                        @click="openTransactionModal()"
                        type="button"
                        title="Tìm giao dịch từ hệ thống"
                      >
                        <i class="bx bx-search"></i> Tìm GD
                      </button>
                    </div>
                  </div>

                  <!-- Hiển thị thông tin giao dịch đã chọn -->
                  <div v-if="selectedTransactions.length > 0" class="mt-2">
                    <div class="alert alert-info py-2 px-3">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <strong>
                            {{
                              selectedTransactions.length === 1
                                ? '1 GD - 1 phiếu thu'
                                : 'Nhiều GD - 1 phiếu thu'
                            }}
                          </strong>
                          <br />
                          <small>
                            Đã chọn {{ selectedTransactions.length }} giao dịch - Tổng tiền:
                            {{ totalSelectedAmount | transformMoney }}đ
                          </small>
                        </div>
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-danger"
                          style="width: 28px"
                          @click="clearSelectedTransactions()"
                          title="Xóa lựa chọn"
                        >
                          <i class="bx bx-x"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <p
                    class="text-primary"
                    v-if="
                      dataReceipt.paymentType === 'CUSTOMER_TRANSFER' &&
                      selectedTransactions.length === 0
                    "
                  >
                    Mã giao dịch phải có tiền tố là
                    `IBSML247`/`EBANKING`/`FPTIBPS`/`IBDN247`/`ACQCH01`/`IRISUSER1`/`TPHSRV`, chứa 1
                    ký tự `/` và các chữ số.
                  </p>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              vid="issuerCode"
              name="Ngân hàng"
              v-if="dataReceipt.paymentType && dataReceipt.paymentType === 'CUSTOMER_TRANSFER'"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label"
                  >Ngân hàng nhận tiền Nextpay <span style="color: red">*</span></label
                >
                <div class="col-sm-7">
                  <Select2
                    class="select-payment-type"
                    v-model="dataReceipt.issuerCode"
                    :options="dataListIssuer"
                    placeholder="Chọn ngân hàng"
                  />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider rules="maxReceipt_2" vid="note" name="Ghi chú">
              <div class="form-group row" slot-scope="{ errors }">
                <label for class="col-sm-3 col-form-label">Ghi chú</label>
                <div class="col-sm-7">
                  <input v-model="dataReceipt.note" type="text" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>

            <div v-if="showReceiptDate" style="height: 30vh"></div>
          </form>

          <div class="col-md-6">
            <div class="img-list-wrapper">
              <UploadMultiple
                @syncFile="syncFile"
                :lsData="fileUploads"
                :maxFile="6"
                title="Ảnh giải trình"
                titleTag="h1"
                titleClass="form-inner-heading"
                uniqueKey="images"
              />
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>

    <div v-if="showModalSuccess">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalSuccess = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/img/noti-success2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messSuccess }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalSuccess = false"
                    data-dismiss="modal"
                  >
                    Bỏ qua
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="showModalEditSuccess">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalEditSuccess = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/img/noti-success2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messSuccess }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="(showModalEditSuccess = false), backToDetail()"
                    data-dismiss="modal"
                  >
                    Đồng ý
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="showModalErr">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalErr = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messErr }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalErr = false"
                    data-dismiss="modal"
                  >
                    Bỏ qua
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="showModalErrCheckTrans">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalErrCheckTrans = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messErr }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="(showModalErrCheckTrans = false), closeEdit()"
                    data-dismiss="modal"
                  >
                    Bỏ qua
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="showModalErrCheckTrans = false"
                    data-dismiss="modal"
                  >
                    Đồng ý
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="showModalCollectMoney">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalCollectMoney = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messErr }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalCollectMoney = false"
                    data-dismiss="modal"
                  >
                    Bỏ qua
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="(showModalCollectMoney = false), collectedMoney(true)"
                    data-dismiss="modal"
                  >
                    Đồng ý
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="showModalCheckBack">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalCheckBack = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img src="@/assets/img/noti-unsuccess2.svg" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ messErr }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalCheckBack = false"
                    data-dismiss="modal"
                  >
                    Không
                  </button>
                  <button
                    type="button"
                    v-if="checkFrom === 'list'"
                    class="btn btn-primary"
                    @click="(showModalCheckBack = false), closeEdit()"
                    data-dismiss="modal"
                  >
                    Đồng ý
                  </button>
                  <button
                    type="button"
                    v-else
                    class="btn btn-primary"
                    @click="(showModalCheckBack = false), backToDetail()"
                    data-dismiss="modal"
                  >
                    Đồng ý
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <TransactionSearchModal
      v-model="showTransactionModal"
      title="Tìm giao dịch gắn cho phiếu thu"
      :multiple="true"
      :max-selection="10"
      @confirm="onTransactionConfirm"
      @selection-change="onSelectionChange"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { ReceiptService } from '@/services/receipts.service'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import { vi } from 'vuejs-datepicker/dist/locale'
  import $ from 'jquery'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import { CommonService } from '@/services/common.service'
  import { v4 as uuidv4 } from 'uuid'
  import TransactionSearchModal from './TransactionSearchModal'

  export default {
    data() {
      return {
        receiptId: this.$route.params.receiptId,
        selectedMC: [],
        dataReceipt: {},
        dataUser: JSON.parse(localStorage.getItem('userData')),
        showModalSelectMC: false,
        dataListMC: [],
        search: {
          limit: 50,
          page: 1,
        },
        showTransactionModal: false,
        selectedTransactions: [],
        loading: false,
        pagination: {
          total: 0,
        },
        dataContract: [],
        dataAppendix: [],
        dataListIssuer: [],
        showModalSuccess: false,
        showModalEditSuccess: false,
        messSuccess: '',
        showModalErr: false,
        showModalErrCheckTrans: false,
        showModalCheckBack: false,
        messErr: '',
        // dataTypePayment: [
        //   { id: 'CUSTOMER_CARD', text: 'Quẹt thẻ khách' },
        //   { id: 'SALE_CARD', text: 'Quẹt thẻ Sales' },
        //   { id: 'CUSTOMER_TRANSFER', text: 'Khách chuyển khoản' }
        // ],
        dataTypePayment: [],
        checkShowMposTrans: false,
        vi: vi,
        showModalCollectMoney: false,
        checkFrom: this.$route.params.checkFrom,
        showReceiptDate: false,
        fileUploads: [],
        showLoading: false,
      }
    },

    components: {
      UploadMultiple,
      TransactionSearchModal,
    },

    mixins: [prepareQueryParamsMixin],

    created() {
      this.configSystem()
      this.fetchData()
      this.getListIssuerMpos()
    },

    updated() {
      this.checkDatePickerOpend()
    },

    computed: {
      ...mapGetters({
        // dataConfigService: 'common/dataConfigService',
        dataConfigMcc: 'common/dataConfigMcc',
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
      totalSelectedAmount() {
        return this.selectedTransactions.reduce((total, transaction) => {
          return total + (transaction.remainingAmount || transaction.amount || 0)
        }, 0)
      },
    },

    filters: {
      transformPaymentType(data, dataTypePayment) {
        const dataReturn = dataTypePayment.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },

    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
      },
    },

    methods: {
      openTransactionModal() {
        this.showTransactionModal = true
      },

      onTransactionConfirm(data) {
        this.selectedTransactions = data.transactions

        // Cập nhật mã giao dịch
        if (data.transactions.length === 1) {
          // Trường hợp 1 GD - 1 phiếu thu
          this.dataReceipt.transactionCode = data.transactions[0].transactionCode
        } else if (data.transactions.length > 1) {
          // Trường hợp nhiều GD - 1 phiếu thu
          const transactionCodes = data.transactions.map(t => t.transactionCode).join('; ')
          this.dataReceipt.transactionCode = `${transactionCodes}`
        }
      },

      onSelectionChange(selectedTransactions) {
        // console.log('Selection changed:', selectedTransactions)
      },

      clearSelectedTransactions() {
        this.selectedTransactions = []
        this.dataReceipt.transactionCode = ''
      },
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.dataTypePayment =
                data.data?.paymentType.map(e => {
                  return { id: e.code, text: e.name }
                }) || []
            }
          })
          .catch(error => console.log(error))
      },
      async checkCloseEdit() {
        this.showModalCheckBack = true
        this.messErr = 'Bạn có chắc chắn muốn huỷ bỏ thao tác không ?'
      },

      async closeEdit() {
        this.$router.push('/list-receipts')
      },

      async backToDetail() {
        this.$router.push(`/detail-receipts/${this.receiptId}`)
      },

      async fetchData() {
        try {
          const data = await ReceiptService.detailReceipts({
            receiptId: this.receiptId,
          })
          if (data.success) {
            this.dataReceipt = data.data
            const mappingData = (arr, type) =>
              arr.forEach(url => {
                const ar = { name: url, url, type, id: uuidv4() }
                this.fileUploads.push(ar)
              })
            mappingData(data.data.uploadImgs, 'images')
          } else {
            alert('Đã xảy ra lỗi')
          }
        } catch (error) {
          console.log(error)
        }
      },

      async updateReceipt() {
        try {
          this.showLoading = true
          const isSuccess = await this.$refs.receiptsEdit.validate()
          if (!isSuccess) {
            this.showModalErr = true
            this.messErr = 'Vui lòng điền đúng thông tin phiếu thu !'
            return
          }
          this.dataReceipt.receiptDate = new Date(this.dataReceipt.receiptDate).getTime()
          const files = await Promise.all(this.fileUploads.map(s => this.sendFile(s)))
          const body = {
            note: this.dataReceipt.note,
            paymentType: this.dataReceipt.paymentType,
            receiptId: this.dataReceipt.receiptId,
            transactionCode: this.dataReceipt.transactionCode,
            receiptDate: this.dataReceipt.receiptDate,
            uploadImgs: files.map(s => s.urlFile),
            issuerCode: this.dataReceipt.issuerCode,
            netAmount: this.dataReceipt.netAmount,
            // selectedTransactions: this.selectedTransactions.length > 0 ? this.selectedTransactions : null
          }
          if (
            this.dataReceipt.paymentType &&
            this.dataReceipt.paymentType !== 'CUSTOMER_TRANSFER'
          ) {
            delete body.issuerCode
          }
          const response = await ReceiptService.updateReceipt(body)
          if (response.code === 1000) {
            this.showModalEditSuccess = true
            this.messSuccess = response.message
          } else {
            this.showModalErr = true
            this.messErr = response.message
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      async getListContract(customerId) {
        try {
          const response = await ReceiptService.listContractByCustomer({
            customerId: customerId,
          })
          if (response.code === 1000) {
            this.dataContract = response.data.map(e => {
              return { id: e.contractId, text: e.code }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },

      async getListIssuerMpos() {
        try {
          const response = await ReceiptService.listIssuerMpos({})
          if (response.code === 1000) {
            this.dataListIssuer = response.data.map(e => {
              return { id: e.issuerCode, text: e.issuerName }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },

      getInfoByAppendix(appendixId) {
        const appendix = this.dataAppendix.filter(e => e.appendixId === appendixId)
        this.dataReceipt.amount = appendix[0].amount
      },

      async checkMposTrans() {
        try {
          if (this.dataReceipt.transactionCode === '') {
            this.showModalErr = true
            this.messErr = 'Vui lòng nhập mã chuẩn ghi/GD'
            return
          }
          const response = await ReceiptService.checkMposTrans({
            receiptId: this.receiptId,
            amount: this.dataReceipt.amount,
            issuerCode: this.dataReceipt.issuerCode,
            transactionCode: this.dataReceipt.transactionCode,
          })
          if (response.code === 1000) {
            this.showModalSuccess = true
            this.messSuccess =
              'Kiểm tra ' +
              this.dataReceipt.transactionCode +
              ' thành công. Giao dịch đang ở trạng thái ' +
              response.data.tranStatusDisplay

            this.dataReceipt.description = response.data.description
            this.dataReceipt.tranStatusCode = response.data.tranStatusCode
            if (
              this.dataReceipt.amount === response.data.amount &&
              (response.data.tranStatusCode === 'SETTLED' ||
                response.data.tranStatusCode === 'TRANSFERED')
            ) {
              this.checkShowMposTrans = true
            }
          } else if (response.code === 999) {
            this.showModalErrCheckTrans = true
            this.messErr =
              'Không kiểm tra được thông tin GD bên mPOS. Vui lòng kiểm tra lại Mã chuẩn chi/mã GD'
          } else if (response.code === 998) {
            this.showModalErrCheckTrans = true
            this.messErr =
              'Mã chuẩn chi tồn tại ở nhiều giao dịch. Vui lòng nhập mã giao dịch và nhấn Kiểm tra lại để hoàn thiện phiếu thu'
          } else if (response.code === 997) {
            this.showModalErr = true
            this.messErr =
              'Số tiền trên giao dịch mPOS khác số tiền trên phiếu thu. Vui lòng kiểm tra lại'
          } else {
            this.showModalErr = true
            this.messErr = response.message
          }
        } catch (error) {
          console.log(error)
        }
      },

      async collectedMoney(allowSaveStatus) {
        try {
          this.dataReceipt.receiptDate = new Date(this.dataReceipt.receiptDate).getTime()
          const response = await ReceiptService.collectedMoneyWithUpdate({
            allowSave: allowSaveStatus,
            note: this.dataReceipt.note,
            paymentType: this.dataReceipt.paymentType,
            receiptDate: this.dataReceipt.receiptDate,
            receiptId: this.dataReceipt.receiptId,
            transactionCode: this.dataReceipt.transactionCode,
            issuerCode: this.dataReceipt.issuerCode,
          })
          if (
            this.dataReceipt.paymentType &&
            this.dataReceipt.paymentType !== 'CUSTOMER_TRANSFER'
          ) {
            delete response.issuerCode
          }
          if (response.code === 1000) {
            this.showModalEditSuccess = true
            this.messSuccess = response.message
          } else {
            this.showModalCollectMoney = true
            this.messErr = response.message
          }
        } catch (error) {
          console.log(error)
        }
      },

      async approveReceipt() {
        try {
          const response = await ReceiptService.approveReceipt({
            receiptId: this.dataReceipt.receiptId,
            description: this.dataReceipt.description,
          })
          if (response.code === 1000) {
            this.showModalEditSuccess = true
            this.messSuccess = response.message
            await this.fetchData()
          } else {
            this.showModalErr = true
            this.messErr = response.message
          }
        } catch (error) {
          console.log(error)
        }
      },

      selectPaymentType() {
        if (this.dataReceipt.paymentType && this.dataReceipt.paymentType === 'CUSTOMER_TRANSFER') {
          this.dataReceipt.issuerCode = this.dataListIssuer[0].id
        } else {
          delete this.dataReceipt.issuerCode
        }
      },

      async sendApproved() {
        try {
          const isSuccess = await this.$refs.receiptsEdit.validate()
          if (!isSuccess) {
            this.showModalErr = true
            this.messErr = 'Vui lòng điền đúng thông tin phiếu thu !'
            return
          }
          this.dataReceipt.receiptDate = new Date(this.dataReceipt.receiptDate).getTime()
          const files = await Promise.all(this.fileUploads.map(s => this.sendFile(s)))
          const body = {
            note: this.dataReceipt.note,
            paymentType: this.dataReceipt.paymentType,
            receiptId: this.dataReceipt.receiptId,
            transactionCode: this.dataReceipt.transactionCode,
            receiptDate: this.dataReceipt.receiptDate,
            uploadImgs: files.map(s => s.urlFile),
            issuerCode: this.dataReceipt.issuerCode,
          }
          if (
            this.dataReceipt.paymentType &&
            this.dataReceipt.paymentType !== 'CUSTOMER_TRANSFER'
          ) {
            delete body.issuerCode
          }

          const response = await ReceiptService.sendToApproveReceipt(body)
          if (response.code === 1000) {
            this.showModalEditSuccess = true
            this.messSuccess = response.message
          } else {
            this.showModalErr = true
            this.messErr = response.message
          }
        } catch (error) {
          console.log(error)
        }
      },

      checkDatePickerOpend() {
        $('.receipt-date').click(() => {
          this.showReceiptDate = true
        })
        $('.receipt-date').focusout(() => {
          this.showReceiptDate = false
        })
      },
      syncFile(files) {
        this.fileUploads = files
      },
      async sendFile(item) {
        if (item.file && item.status !== 'uploaded') {
          const formData = new FormData()
          formData.append('files', item.file)
          formData.append('folderName', 'NextCrm')
          const data = await CommonService.uploadImg(formData)
          const urlFile = data.data[0]
          item.url = urlFile
          item.status = 'uploaded'
          return { urlFile, type: item.type }
        } else return { urlFile: item.url, type: item.type }
      },
    },
  }
</script>

<style scoped>
  .placeholder {
    background: #f0f0f0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-family: Helvetica;
  }

  .placeholder:hover {
    background: #e0e0e0;
  }

  .receipts-add {
    margin-top: -1rem;
  }

  .pagination-bottom {
    margin-bottom: -1rem;
  }
</style>
